export default __webpack_public_path__ + "static/media/275.1d0ae17a.png";